<template>
  <div v-if="scrape" class="mt-4">
    <b-taglist attached>
        <b-tag size="is-medium" type="is-success">{{ scrape.Contact || '?' }}</b-tag>
        <b-tag v-if="scrape.PhoneNumber" size="is-medium" type="is-dark">{{ scrape.PhoneNumber }}</b-tag>
    </b-taglist>
    <p>Conversation snapshot contained {{ scrape.Messages.length }} messages.</p>
  </div>  
</template>

<script>
import { isScrape, parseScrape } from '@/services/chats/snapshots'
export default {
  props: {
    n: Object
  },
  computed: {
    scrape () {
      if (!this.n) return null
      if (!isScrape(this.n)) return null
      return parseScrape(this.n.metaData.content)
    }
  }
}
</script>